var _excluded = ["style", "className", "closeButton", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { omit } from "lodash-es";
import { Close } from "../../icons";
import { Context } from "./Modal";
import { onEnter } from "../../helpers";
var ModalHeader = function ModalHeader(_ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$closeButton = _ref.closeButton,
    closeButton = _ref$closeButton === void 0 ? false : _ref$closeButton,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? "Modal Title" : _ref$children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var context = useContext(Context);
  return /*#__PURE__*/React.createElement("div", _extends({}, omit(restProps, "closeButton"), {
    className: "tui-modal-header ".concat(className),
    style: style
  }), children, closeButton && /*#__PURE__*/React.createElement("span", {
    className: "close-button",
    tabIndex: "0",
    role: "button",
    onClick: context.onCancel,
    onKeyPress: onEnter(context.onCancel)
  }, /*#__PURE__*/React.createElement(Close, {
    tabIndex: "-1"
  })));
};
ModalHeader.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  closeButton: PropTypes.bool,
  children: PropTypes.node
};
export default ModalHeader;
//# sourceMappingURL=ModalHeader.js.map